import { usePersistQueryContext as o } from "../../contexts/share/PersistQueryContext.js";
import * as n from "ramda";
import { useEffect as i } from "react";
const f = (r) => {
  const t = r.join(","), {
    persistKeysRef: e,
    setPersistKeys: s
  } = o();
  i(() => {
    e.current = n.union(r, e.current), s(e.current);
  }, [t]);
};
export {
  f as default
};
//# sourceMappingURL=usePersistQuery.js.map
